import { useEffect, ReactNode } from 'react'

import { expandedNavItemsContext } from '../../contexts'
import { useLocalStorage } from 'react-use'

interface ExpandedNavItemProviderProps {
  children: ReactNode
  programName?: string
}


// Provides children with "expanded nav items" context
function ExpandedNavItemProvider({ children, programName }: ExpandedNavItemProviderProps) {
  // This value is stored in local storage
  const [expandedNavItems, setExpandedNavItems] = useLocalStorage(
    'expanded-nav-items',
    []
  )

  const [
    expandedNavItemProgramName,
    setExpandedNavItemProgramName,
  ] = useLocalStorage('expanded-program-name', '')

  useEffect(() => {
    if (expandedNavItemProgramName !== programName) setExpandedNavItems([])
  }, [programName, expandedNavItemProgramName, setExpandedNavItems])
  // Note: Both value and setter are passed down to consumers
  return (
    <expandedNavItemsContext.Provider
      value={[
        expandedNavItems,
        expandedNavItemProgramName,
        setExpandedNavItems,
        setExpandedNavItemProgramName,
      ]}
    >
      {children}
    </expandedNavItemsContext.Provider>
  )
}


export default ExpandedNavItemProvider
